// Interfaces
import { IStyles } from '../../resource';

// Define styles
const styles: IStyles = {
  container: () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  }),
  paginationContainer: (theme) => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    px: theme.spacing(2),
  }),
  sortContainer: (theme) => ({
    position: 'absolute',
    right: 0,
    gap: theme.spacing(2),
  }),
  sortField: (theme) => ({
    minWidth: 180,
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.spacing(8, 0, 8, 0),
    },
  }),
  card: (theme) => ({
    position: 'relative',
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: theme.spacing(30, 0, 30, 0),
    overflow: 'hidden',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    ':hover': {
      bgcolor: theme.palette.secondary.main,
      boxShadow: theme.shadows[1],
      '.MuiTypography-root': {
        color: `${theme.palette.common.white} !important`,
      },
    },
  }),
  cardHeader: (theme) => ({
    p: theme.spacing(15, 16, 12),
    borderBottom: `1px solid ${theme.palette.secondary.main}`,
    flex: 1,
    '.MuiTypography-body2': {
      opacity: 0.5,
      mt: theme.spacing(12),
    },
    display: 'flex'
  }),
  thumbnail: () => ({
    minHeight: 368,
    maxHeight: 368,
    overflow: 'hidden',
    img: {
      width: '100%',
    },
  }),
  automationBadge: (theme) => ({
    position: 'absolute',
    bottom: 16,
    right: 16,
    zIndex: 1,
    backgroundColor: 'white',
    width: '32px !important',
    height: '32px !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50% !important',
  }),
  cardBox: () => ({
    marginTop: '0 !important',
    width: '100% !important',
  }),
  cardAction: (theme) => ({
    m: theme.spacing(16),
    display: 'flex',
    justifyContent: 'flex-end',
    minHeight: 48,
  }),
  listItem: (theme) => ({
    display: 'flex',
    alignItems: 'center',
    p: theme.spacing(15, 24, 16),
    justifyContent: 'space-between',
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: theme.spacing(16, 0, 16, 0),
    ':hover': {
      bgcolor: theme.palette.secondary.main,
      boxShadow: theme.shadows[1],
      '.MuiTypography-root': {
        color: `${theme.palette.common.white} !important`,
      },
    },
    '.MuiTypography-body2': {
      opacity: 0.5,
      mt: theme.spacing(1),
    },
  }),
  listAction: () => ({
    position: 'absolute',
    right: 24,
  }),
};

// Export styles
export default styles;
